import { TokenService } from '@services/internal';
import { TListener } from '@services/internal/token';
import React from 'react';

/**
 *Use session of current user
 * @returns session
 */
function useTokenService() {
  const [session, setSession] = React.useState(TokenService.getSessionDangerously);

  React.useEffect(() => {
    const _listener: TListener = (ns) => {
      setSession(ns);
    };

    const removeListener = TokenService.addEventListener(_listener);

    return () => {
      if (removeListener) {
        removeListener();
      }
    };
  }, []);

  return { session };
}

export default useTokenService;
